var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showoff
    ? _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showoff,
            title: "选择合作模式",
            width: "800px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showoff = $event
            },
          },
        },
        [
          _c("div", { staticClass: "mode-selector" }, [
            _c(
              "div",
              {
                staticClass: "mode-button",
                class: { selected: _vm.selectedModes.includes("1") },
                on: {
                  click: function ($event) {
                    return _vm.toggleMode("1")
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-shop" }),
                _c("span", [_vm._v("平台开店")]),
                _vm.selectedModes.includes("1")
                  ? _c("i", { staticClass: "el-icon-check check-icon" })
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "mode-button",
                class: { selected: _vm.selectedModes.includes("2") },
                on: {
                  click: function ($event) {
                    return _vm.toggleMode("2")
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-connection" }),
                _c("span", [_vm._v("入驻供应链")]),
                _vm.selectedModes.includes("2")
                  ? _c("i", { staticClass: "el-icon-check check-icon" })
                  : _vm._e(),
              ]
            ),
          ]),
          _c("div", { staticClass: "display-area" }, [
            _c("div", { staticClass: "process-display" }, [
              _c("div", { staticClass: "process-title" }, [_vm._v("平台开店")]),
              _c("div", { staticClass: "process-label" }, [
                _vm._v("流程说明:"),
              ]),
              _c("div", { staticClass: "process-image" }, [
                _c("img", {
                  attrs: {
                    src: "https://wsnbh-img.hzanchu.com/default/589823865222127616.png",
                    alt: "平台开店流程图",
                  },
                }),
              ]),
              _c(
                "div",
                { staticClass: "agreement-link" },
                [
                  _c("el-link", { attrs: { type: "primary" } }, [
                    _vm._v("（平台开店协议）"),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "process-display" }, [
              _c("div", { staticClass: "process-title" }, [
                _vm._v("入驻供应链"),
              ]),
              _c("div", { staticClass: "process-label" }, [
                _vm._v("流程说明:"),
              ]),
              _c("div", { staticClass: "process-image" }, [
                _c("img", {
                  attrs: {
                    src: "https://wsnbh-img.hzanchu.com/default/589823557188247552.png",
                    alt: "供应链合作流程图",
                  },
                }),
              ]),
              _c(
                "div",
                { staticClass: "agreement-link" },
                [
                  _c("el-link", { attrs: { type: "primary" } }, [
                    _vm._v("（供应链合作协议）"),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "btn-box" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitClick } },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                { attrs: { type: "default" }, on: { click: _vm.cancelClick } },
                [_vm._v("跳过")]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }